import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class CalendarAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Calendar';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'calendars';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'description',
            'isSystem',
            'visibility',
            'calendarCategoryUuid',
            'propertyUuid',
            'stageUuid',
            'channelUuid',
            'workspaceUuid',
            'organizationUuid',
            'ownerWorkspaceMemberUuid',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            isSystem: {
                type: 'string',
                presence: true,
            },
            visibility: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
                inclusion: [
                    'public',
                    'private',
                ],
            },
            calendarCategoryUuid: {
                type: 'string',
                presence: true,
            },
            ownerWorkspaceMemberUuid: {
                type: 'string',
                presence: true,
            },
            meta: {
                type: 'string',
                presence: true,
            },
            propertyUuid: {
                type: 'string',
            },
            stageUuid: {
                type: 'string',
            },
            channelUuid: {
                type: 'string',
            },
            workspaceUuid: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
            },
        };
    }

}

export default CalendarAppResource;
